// extracted by mini-css-extract-plugin
export default {"overlayLink":"ScrollDown_overlayLink__SEGyR","overlayLinkLabel":"ScrollDown_overlayLinkLabel__HSgpk"};